import axios from 'axios';
import { Feeder } from 'views/production-systems/features/farm-setup/types/feeders.type';
import { UpdateAssignedFeedersInput } from 'views/production-systems/features/farm-setup/types/update-feeders-input.type';

// POST FeederToPond
// /ewosapi/v1/shrimps/feeder/registration/{globalCompanyId}
export const putFeeders = async (globalSiteId: string, request: UpdateAssignedFeedersInput) => {
  const res = await axios.post<Feeder>(`/ewosapi/v1/shrimps/feeder/registration?globalSiteId=${globalSiteId}`, request);
  return res.data;
};
